import React, { useState, useEffect, useMemo, useRef } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import redirectURL from "../redirectURL";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoMdAdd } from "react-icons/io";
import Select from "react-select";

const PmVendorWhMappingMaster = () => {
  const gridApi = useRef(null);
  const gridColumnApi = useRef(null);
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [rowData, setRowData] = useState([]);
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null);
  const [sliderCl, setSliderCl] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  
  // Dropdown options states
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [vendorOptions, setVendorOptions] = useState([]);
  
  // Dropdown selection states
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(null);
  
  const [editFormData, setEditFormData] = useState({
    warehouse_id: "",
    warehouse_name: "",
    vendor_id: "",
    vendor_name: "",
    vendor_location: "",
    transit_time_days: ""
  });

  // Select Styles
  const selectStyles = {
    control: (base) => ({
      ...base,
      padding: '1px',
      borderRadius: '5px',
      border: '1px solid #d9d9d9',
      minHeight: '38px'
    }),
    singleValue: (base) => ({
      ...base,
      fontWeight: 'normal',
      color: '#333',
      fontSize: "12px"
    }),
    option: (base, state) => ({
      ...base,
      fontSize: "13px",
      fontWeight: state.isSelected ? 'normal' : 'normal',
    })
  };

  // Column Definitions with Delete Action
  const actionColumn = {
    headerName: "",
    field: "actions",
    sortable: false,
    filter: false,
    width: "90px",
    cellClass: "custom-cell", 
    cellRendererFramework: (params) => (
      <div style={{
        height: "36px", 
        padding: 0, 
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center"
      }}>
        <button
          title="Delete"
          style={{
            height: "30px",
            width: "60px",
            backgroundColor: "transparent",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
          onClick={() => handleDelete(params.data)}
        >
          <RiDeleteBin5Line style={{ color: "red", fontSize: "20px" }} />
        </button>
      </div>
    ),
  };

  const columnWithDefs = [
    actionColumn,
    {
      headerName: "Vendor ID",
      field: "vendor_id",
      sortable: true,
      resizable: true,
      width: 120,
    },
    {
      headerName: "Vendor Name",
      field: "vendor",
      sortable: true,
      resizable: true,
      width: 250,
    },
    {
      headerName: "Vendor Location",
      field: "vendor_location",
      sortable: true,
      resizable: true,
      width: 150,
    },
    {
      headerName: "Warehouse ID",
      field: "wh_id",
      sortable: true,
      resizable: true,
      width: 130,
    },
    {
      headerName: "Warehouse Name",
      field: "warehouse",
      sortable: true,
      resizable: true,
      width: 200,
    },
    {
      headerName: "Transit Time (Days)",
      field: "transit_time_days",
      sortable: true,
      resizable: true,
      width: 160,
      valueFormatter: (params) => {
        return params.value ? params.value.toString() + ' days' : '0 days';
      }
    },
    {
      headerName: "Inserted Date",
      field: "inserted_date",
      sortable: true,
      resizable: true,
      width: 150,
      hide: true,
      valueFormatter: (params) => {
        if (params.value) {
          return new Date(params.value).toLocaleDateString();
        }
        return '';
      }
    },
    {
      headerName: "Updated Date",
      field: "updated_date",
      sortable: true,
      resizable: true,
      width: 150,
      hide: true,
      valueFormatter: (params) => {
        if (params.value) {
          return new Date(params.value).toLocaleDateString();
        }
        return '';
      }
    }
  ];

  // Get Warehouse Options from pm_warehouse_master - Show warehouse_id
  const getWarehouseOptions = async () => {
    try {
      const response = await redirectURL.post("masters/getPmWarehouseData", {});
      if (response.status === 200 && response.data.data) {
        const options = response.data.data.map(item => ({
          value: item.warehouse_id,
          label: item.warehouse_id, // Show warehouse_id instead of warehouse_name
          data: item // Store full data for auto-fill
        }));
        setWarehouseOptions(options);
      }
    } catch (error) {
      console.error("Error fetching warehouse options:", error);
    }
  };

  // Get Vendor Options from pm_vendor_master - Show vendor_id
  const getVendorOptions = async () => {
    try {
      const response = await redirectURL.post("masters/getPmVendorData", {});
      if (response.status === 200 && response.data.data) {
        const options = response.data.data.map(item => ({
          value: item.vendor_id,
          label: item.vendor_id, // Show vendor_id instead of vendor_name
          data: item // Store full data for auto-fill
        }));
        setVendorOptions(options);
      }
    } catch (error) {
      console.error("Error fetching vendor options:", error);
    }
  };

  // Handle Warehouse Selection
  const handleWarehouseChange = (selectedOption) => {
    setSelectedWarehouse(selectedOption);
    if (selectedOption) {
      const warehouseData = selectedOption.data;
      setEditFormData(prev => ({
        ...prev,
        warehouse_id: warehouseData.warehouse_id,
        warehouse_name: warehouseData.warehouse_name || ""
      }));
    } else {
      // Clear warehouse fields if selection is cleared
      setEditFormData(prev => ({
        ...prev,
        warehouse_id: "",
        warehouse_name: ""
      }));
    }
  };

  // Handle Vendor Selection
  const handleVendorChange = (selectedOption) => {
    setSelectedVendor(selectedOption);
    if (selectedOption) {
      const vendorData = selectedOption.data;
      setEditFormData(prev => ({
        ...prev,
        vendor_id: vendorData.vendor_id,
        vendor_name: vendorData.vendor_name || "",
        vendor_location: vendorData.location || ""
      }));
    } else {
      // Clear vendor fields if selection is cleared
      setEditFormData(prev => ({
        ...prev,
        vendor_id: "",
        vendor_name: "",
        vendor_location: ""
      }));
    }
  };

  // Reset Form Data
  const resetFormData = () => {
    setEditFormData({ 
      warehouse_id: "",
      warehouse_name: "",
      vendor_id: "",
      vendor_name: "",
      vendor_location: "",
      transit_time_days: ""
    });
    setSelectedWarehouse(null);
    setSelectedVendor(null);
  };

  // Hide Overlay and Slider
  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    resetFormData();
  };

  // Add New Vendor Warehouse Mapping
  const onClickAddNewMapping = async () => {
    // Load dropdown options when opening slider
    await getWarehouseOptions();
    await getVendorOptions();
    
    resetFormData();
    setSliderOpen(true);
    setSliderType(1);
    setSliderCl("slider-25");
    setSliderTitle("Add New Vendor Warehouse Mapping");
    setOverlyBlock("show-m");
  };

  // Handle Delete
  const handleDelete = (row) => {
    setSelectedRow(row);
    setShowDeletePopup(true);
    setOverlayBlock("show-m");
  };

  // Sidebar Configuration
  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);

  // Status Panel Configuration
  const statusPanel = {
    statusPanels: [
      {
        statusPanel: "agTotalAndFilteredRowCountComponent",
        align: "left"
      },
      {
        statusPanel: "agTotalRowCountComponent",
        align: "center"
      },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" }
    ]
  };

  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    minWidth: 100,
  };

  // Get PM Vendor Warehouse Mapping Data
  const getPmVendorWhMappingData = async () => {
    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");
      
      const response = await redirectURL.post("masters/getPmVendorWhMappingData", {});
      
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          setRowData(response.data.data);
          setTimeout(() => autoSizeAllColumns(), 100);
        } else {
          setBasicTitle("No PM Vendor Warehouse Mapping data found");
          setBasicType("info");
          setShow(true);
        }
      }
    } catch (error) {
      console.error("Error fetching PM Vendor Warehouse Mapping data:", error);
      setBasicTitle("Failed to fetch PM Vendor Warehouse Mapping data");
      setBasicType("error");
      setShow(true);
    } finally {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    }
  };

  // Auto Size Columns
  const autoSizeAllColumns = () => {
    if (gridColumnApi.current) {
      const allColumns = gridColumnApi.current.getAllColumns();
      if (allColumns?.length) {
        const allColumnIds = allColumns.map((col) => col.getColId());
        gridColumnApi.current.autoSizeColumns(allColumnIds, false);
      }
    }
  };

  // Grid Ready
  const onGridReady = (params) => {
    gridApi.current = params.api;
    gridColumnApi.current = params.columnApi;
    setTimeout(() => autoSizeAllColumns(), 100);
  };

  // Close Alert
  const closeAlert = () => {
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
    setShowDeletePopup(false);
    setSliderOpen(false);
    resetFormData();
  };

  // Close Slider
  const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    resetFormData();
  };

  // Handle Input Change for Transit Time
  const handleInputChange = (field, value) => {
    setEditFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Add New Vendor Warehouse Mapping
  const handleAddMapping = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    
    // First check if dropdowns are selected
    if (!selectedWarehouse) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Please select a Warehouse");
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }

    if (!selectedVendor) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Please select a Vendor");
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }

    // Validate transit time if provided
    if (editFormData.transit_time_days && 
        (isNaN(Number(editFormData.transit_time_days)) || Number(editFormData.transit_time_days) < 0)) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Transit Time must be a valid positive number");
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }

    const params = {
      wh_id: editFormData.warehouse_id,
      warehouse: editFormData.warehouse_name,
      vendor_id: editFormData.vendor_id,
      vendor: editFormData.vendor_name,
      vendor_location: editFormData.vendor_location,
      transit_time_days: parseInt(editFormData.transit_time_days) || 0
    };

    try {
      const response = await redirectURL.post("masters/addPmVendorWhMapping", params);
      
      if (response.status === 200 && response.data.status === "success") {
        await getPmVendorWhMappingData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle("Vendor Warehouse Mapping Added Successfully");
        setSliderOpen(false);
        setOverlyBlock("show-n");
        
        // RESET FORM DATA AFTER SUCCESSFUL ADD
        resetFormData();
        
        // User Action Triggering
        const userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "New Vendor Warehouse Mapping Added",
          status: "Success",
          path: window.location.pathname
        };
        triggerUserAction(userData);
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle(response.data.message || "Failed to add Vendor Warehouse Mapping");
        
        // User Action Triggering
        const userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "New Vendor Warehouse Mapping Added",
          status: "Failure",
          path: window.location.pathname
        };
        triggerUserAction(userData);
      }
    } catch (error) {
      const message = error.response?.data?.message || "An error occurred";
      setShow(true);
      setBasicType("info");
      setBasicTitle(message);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      
      // User Action Triggering
      const userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "New Vendor Warehouse Mapping Added",
        status: "Failure",
        path: window.location.pathname
      };
      triggerUserAction(userData);
    }
  };

  // Delete Vendor Warehouse Mapping
  const onClickingPopupDeleteBtn = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    
    try {
      const response = await redirectURL.post("masters/deletePmVendorWhMapping", {
        id: selectedRow._id
      });
      
      if (response.data.status === "success") {
        await getPmVendorWhMappingData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShowDeletePopup(false);
        setShow(true);
        setBasicType("success");
        setBasicTitle("Vendor Warehouse Mapping Deleted Successfully");
        
        // User Action Triggering
        const userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Vendor Warehouse Mapping Deleted",
          status: "Success",
          path: window.location.pathname
        };
        triggerUserAction(userData);
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to delete Vendor Warehouse Mapping");
        
        // User Action Triggering
        const userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Vendor Warehouse Mapping Deleted",
          status: "Failure",
          path: window.location.pathname
        };
        triggerUserAction(userData);
      }
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to delete Vendor Warehouse Mapping");
      
      // User Action Triggering
      const userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Vendor Warehouse Mapping Deleted",
        status: "Failure",
        path: window.location.pathname
      };
      triggerUserAction(userData);
    }
  };

  // Cancel Delete
  const onClickDeletePopupCancelBtn = () => {
    setOverlayBlock("show-n");
    setShowDeletePopup(false);
  };

  // Trigger User Action
  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata);
  };

  // Initialize Data
  useEffect(() => {
    getPmVendorWhMappingData();
  }, []);

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px" }}
          />
        </div>

        <div className="row" style={{ fontSize: "1rem", fontWeight: "bold", fontFamily: "Arial, sans-serif" }}>
          <div className="col-sm-12">
            <h1 className="col-sm-12" style={{ color: "#B9366D", fontSize: "18px", fontWeight: "bold", fontFamily: "sans-serif" }}>
              Warehouse Vendor Mapping
            </h1>
          </div>
          
          {/* Add Button - Right Aligned */}
          <div className="col-sm-12 d-flex justify-content-end">
            <button 
              onClick={onClickAddNewMapping}
              style={{
                ...addButtonStyle,
                backgroundColor: "#93385D",
                color: "#fff",
                border: "2px solid #93385D",
              }}
            >
              <IoMdAdd style={{ color: "#fff", fontSize: "18px" }} />
              {" Add"}
            </button>
          </div>

          {/* Data Grid */}
          <div className="col-sm-12 p-0 pl-2 mt-5">
            <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
              <AgGridReact
                rowData={rowData}
                columnDefs={columnWithDefs}
                defaultColDef={defaultColDef}
                domLayout="normal"
                sideBar={sideBar}
                statusBar={statusPanel}
                pagination={true}
                paginationPageSize={100}
                enableRangeSelection={true}
                gridOptions={{ suppressHorizontalScroll: false }}
                onGridReady={onGridReady}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Slider for Add */}
      <div className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`} style={{ width: "25%" }}>
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p className="m-0p" style={{ cursor: "pointer" }} onClick={onClickingSliderCloseIcon}>
            X&nbsp;&nbsp;&nbsp;
          </p>
        </div>

        {/* Add Form */}
        {sliderType === 1 && (
          <div style={{ 
            display: "flex", 
            flexDirection: "column", 
            height: "100%", 
            overflow: "hidden" 
          }}>
            <form style={{ 
              flexGrow: 1, 
              overflowY: "auto", 
              padding: "20px",
              height: "100%"
            }}>
              <div style={{ paddingBottom: "20px" }}>
                {/* Warehouse ID Dropdown */}
                <div className="form-group">
                  <label htmlFor="warehouse_id" style={labelStyle}>
                    Warehouse ID <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    id="warehouse_id"
                    options={warehouseOptions}
                    value={selectedWarehouse}
                    onChange={handleWarehouseChange}
                    placeholder="Select Warehouse ID"
                    styles={selectStyles}
                    isClearable
                    isSearchable
                    required
                  />
                </div>

                {/* Warehouse Name (Auto-filled) */}
                <div className="form-group">
                  <label htmlFor="warehouse_name" style={labelStyle}>
                    Warehouse Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="warehouse_name"
                    value={editFormData.warehouse_name}
                    placeholder="Auto-filled from Warehouse selection"
                    style={{
                      ...inputStyle,
                      backgroundColor: "#f9f9f9",
                      cursor: "not-allowed",
                      color: "#666"
                    }}
                    disabled
                    required
                  />
                </div>

                {/* Vendor ID Dropdown */}
                <div className="form-group">
                  <label htmlFor="vendor_id" style={labelStyle}>
                    Vendor ID <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    id="vendor_id"
                    options={vendorOptions}
                    value={selectedVendor}
                    onChange={handleVendorChange}
                    placeholder="Select Vendor ID"
                    styles={selectStyles}
                    isClearable
                    isSearchable
                    required
                  />
                </div>

                {/* Vendor Name (Auto-filled) */}
                <div className="form-group">
                  <label htmlFor="vendor_name" style={labelStyle}>
                    Vendor Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="vendor_name"
                    value={editFormData.vendor_name}
                    placeholder="Auto-filled from Vendor selection"
                    style={{
                      ...inputStyle,
                      backgroundColor: "#f9f9f9",
                      cursor: "not-allowed",
                      color: "#666"
                    }}
                    disabled
                    required
                  />
                </div>

                {/* Vendor Location (Auto-filled) */}
                <div className="form-group">
                  <label htmlFor="vendor_location" style={labelStyle}>
                    Vendor Location <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="vendor_location"
                    value={editFormData.vendor_location}
                    placeholder="Auto-filled from Vendor selection"
                    style={{
                      ...inputStyle,
                      backgroundColor: "#f9f9f9",
                      cursor: "not-allowed",
                      color: "#666"
                    }}
                    disabled
                    required
                  />
                </div>

                {/* Transit Time */}
                <div className="form-group">
                  <label htmlFor="transit_time_days" style={labelStyle}>
                    Transit Time (Days)
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="transit_time_days"
                    value={editFormData.transit_time_days}
                    onChange={(e) => handleInputChange('transit_time_days', e.target.value)}
                    placeholder="Enter Transit Time in Days"
                    style={inputStyle}
                    min="0"
                  />
                </div>

                {/* Submit Button */}
                <div style={submitButtonContainerStyle}>
                  <button
                    type="button"
                    onClick={handleAddMapping}
                    style={submitButtonStyle}
                  >
                    ADD
                  </button>
                </div>
              </div>
            </form>
          </div>
        )}
      </div>

      {/* Delete Confirmation Popup */}
      {showDeletePopup && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={deletePopupStyle}
        >
          <div className="inventory-delete-popup">
            <p style={deletePopupTextStyle}>
              {`Are you sure you want to delete mapping for ${selectedRow ? selectedRow.vendor_name : ""} - ${selectedRow ? selectedRow.warehouse : ""}?`}
            </p>
            <div className="d-flex justify-content-center align-items-center">
              <button className="btn btn-danger" onClick={onClickingPopupDeleteBtn}>
                Delete
              </button>
              <button className="btn btn-secondary" onClick={onClickDeletePopupCancelBtn}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Loader and Overlays */}
      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div className={`overlay-block ${overlayBlock}`}></div>
      <div className={"overly-block " + overlyBlock} onClick={hideOverlySlideBlock}></div>
    </>
  );
};

// Styles
const addButtonContainerStyle = { textAlign: "right", marginTop: "10px" };
const addButtonStyle = {
  padding: "8px 20px",
  backgroundColor: "#93385D",
  color: "#fff",
  fontFamily: "sans-serif",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "0.9rem",
  fontWeight: "bold",
  display: "flex",
  alignItems: "center",
  gap: "5px"
};

const labelStyle = {
  fontSize: "0.9rem",
  fontWeight: "bold",
  color: "#333",
  marginBottom: "8px",
  display: "block"
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  borderRadius: "5px",
  border: "1px solid #ccc",
  fontSize: "0.9rem",
  marginBottom: "15px"
};

const submitButtonContainerStyle = {
  textAlign: "right",
  marginTop: "20px",
  paddingTop: "15px",
  borderTop: "1px solid #eee"
};

const submitButtonStyle = {
  backgroundColor: "#93385D",
  color: "#fff",
  padding: "10px 30px",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "0.9rem",
  fontWeight: "bold"
};

const deletePopupStyle = {
  position: "fixed",
  top: "40%",
  left: "40%",
  zIndex: "1003",
  backgroundColor: "rgba(255, 255, 255, 0.95)",
  padding: "20px",
  borderRadius: "10px",
  boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
};

const deletePopupTextStyle = {
  color: "grey",
  fontSize: "16px",
  textAlign: "center",
  fontWeight: "bold",
  marginBottom: "20px",
};

export default PmVendorWhMappingMaster;